<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_faq") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.questionAr')"
            v-model.trim="data.question_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.questionEn')"
            v-model.trim="data.question_en"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.answerAr')"
            v-model.trim="data.answer_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.answerEn')"
            v-model.trim="data.answer_en"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditFaq",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        question_ar: null,
        question_en: null,
        answer_ar: null,
        answer_en: null,
      },
    };
  },

  methods: {
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async getDataToEdit() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `frequentlyAskedQuestions/${this.$route.params.id}`,
        });
        const item = res.data?.data?.FrequentlyAskedQuestion || {};
        this.data.question_ar = item.question_ar;
        this.data.question_en = item.question_en;
        this.data.answer_ar = item.answer_ar;
        this.data.answer_en = item.answer_en;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load FAQ"
        );
      }
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("question[ar]", this.data.question_ar || "");
      REQUEST_DATA.append("question[en]", this.data.question_en || "");
      REQUEST_DATA.append("answer[ar]", this.data.answer_ar || "");
      REQUEST_DATA.append("answer[en]", this.data.answer_en || "");
      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `frequentlyAskedQuestions/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/questions/all" });
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to edit FAQ"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },

  created() {
    this.getDataToEdit();
  },
};
</script>
